import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const ttpRegistriesUrl = `${SERVER_API}/ttp-registries`;
export const ttpFoundersUrl = `${ttpRegistriesUrl}/ttp-organizations/founders`;

export const TTP_FOUNDERS_API = {
  ...generateCrudEndpoints(ttpFoundersUrl),
};
